module.exports = __webpack_public_path__ + "static/media/cerrar-definicion.634664ec.svg";